<template>
  <CContainer>
    <CRow class="mb-2">
      <CCol col="sm-6" class="pt-2">
        <span class="my-5"><strong>Registros:</strong> {{ numberRecords }}</span>
      </CCol>
      <CCol col="sm-6" class="d-flex justify-content-end">
        <JsonExcel
          name="SerialesProducto.xls"
          worksheet="Seriales"
          :fields="fieldsExport"
          :data="records">
          <CButton 
            color="success" 
            variant="outline">
            <i class="bi bi-file-earmark-excel h5 mr-2"></i>
            <span>Excel</span>
          </CButton>
        </JsonExcel>
        <CButton 
          color="danger" 
          variant="outline"
          class="ml-2" @click="event => {
            event.stopPropagation()
            downloadDocument()
          }">
          <i class="bi bi-file-earmark-pdf h5 mr-2"></i>
          <span>PDF</span>
        </CButton>
      </CCol>
    </CRow>
    <CDataTable
      hover
      responsive
      pagination
      :itemsPerPage="5"
      :items="records"
      :fields="gridFields">
      <template #producto="{item}">
        <td>
          <div>
            <span>{{ item.descripcion }}</span>
          </div>
          <div>
            <h5>{{ item.codigo }}</h5>
          </div>
        </td>
      </template>
      <template #serial="{item}">
        <td>
          <div>
            <span><i class="bi bi-upc-scan mr-2"></i>{{ item.numero_Serial }}</span>
          </div>
          <div>
            <span><i class="bi bi-calendar3 mr-2"></i>{{ moment(item.fecha_Creacion).format("DD/MM/YYYY") }}</span>
          </div>
          <div>
            <span><i class="bi bi-clock mr-2"></i>{{ moment(item.fecha_Creacion).format("hh:mm:ss") }}</span>
          </div>
        </td>
      </template>
    </CDataTable>

    <CElementCover v-show="loading"/>
  </CContainer>
</template>

<script>
  import moment from "moment";
  import JsonExcel from "vue-json-excel";
  import { downloadFileObject } from "../../api"
  import { dataGridSerialesDocumento } from "../../apiDataGrids"
  import { descargarSerialesDocumentoPDF } from "../../apiReports"

  const gridFields = [
    {
      key: "producto",
      label: "Producto",
      _style: "text-align:center"
    },
    {
      key: "serial",
      label: "Serial",
      _style: "text-align:center"
    }
  ]
  const fieldsExport = {
    "Código": "codigo",
    "Descripción": "descripcion",
    "Serial": "numero_Serial",
    "Fecha Creación": "fecha_Creacion"
  }

  export default {
    name: "ProductSerialsDocument",
    data () {
      return {
        loading: false,
        gridFields,
        fieldsExport,
        records: [],
        numberRecords: 0
      }
    },
    components: {
      JsonExcel
    },
    props: {
      idDocument: String
    },
    methods: {
      moment,
      async getData() {
        if (this.idDocument) {
          this.loading = true

          try {
            // const { count, results } = await dataGridSerialesDocumento(this, this.idDocument)
            const results = await dataGridSerialesDocumento(this, this.idDocument)

            this.records = results
            this.numberRecords = this.records.length
          } catch(error) {
            this.$store.commit("setAlert", {
              color: "danger",
              message: "NO se pudo cargar los datos de Seriales Productos del Documento.",
              show: 5
            })
          } finally {
            this.loading = false
          }
        }
      },
      async downloadDocument() {
        this.loading = true

        try {
          const { response } = await descargarSerialesDocumentoPDF(this, this.idDocument)
          const { nombreArchivo, contenidoArchivo } = response

          downloadFileObject(nombreArchivo, "pdf", contenidoArchivo)
        } catch(error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Ocurrio un error al descargar el archivo PDF!",
            show: 5
          })
        } finally {
          this.loading = false
        }
      }
    },
    mounted() {
      this.getData()
    }
  }
</script>
